<div class="row">
    <div class="col-12">
        <div class="row pt-1">
            <div class="col-12 scroll-style">
              <table class="table table-bordered table-responsive">
                <thead>
                  <tr class="table-secondary">
                    <th scope="col" class="centertext">Status Date</th>
                    <th scope="col" class="centertext">Status Name</th>
                    <th scope="col" class="centertext">Comments</th>
                    <th scope="col" class="centertext">Status Changed By</th>
                    <th scope="col" class="centertext">Reasons</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let s of getStatus;let i=index">
                    <td class="centertext">{{s.Status_Date | date: "dd/MM/yy"}}</td>
                    <td class="centertext">{{s.Study_Material_Status_Type_Name}}</td>
                    <td ><div [innerHtml]="s.Comment_Text"></div></td>
                    <td class="centertext">{{s.Status_Owner}}</td>
                    <td>{{s.Action_Reason_Type_Name}}</td>

                  </tr>
                </tbody>
              </table>
              <div class="col-12">
                <div class="d-flex justify-content-center pt-1 pb-1">

                  <div class="px-1">
                    <button type="button" class="btn btn-sm bg-light border" (click)="closepopup()">Close</button>

                  </div>
                </div>
              </div>


      </div>

    </div>

    </div>



</div>
